/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/regenerate-courier-parcel-loader.js
 * Source files:
 *   - courierParcel.njk
 */

export const COURIER_PARCEL_TEMPLATE = `{% if isA4 %}
  <div class="a4-container">
    <div class="a4-hdr-row">
      <div class="a4-hdr-left">
        {% if logoUrl %}
          <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
        {% endif %}
      </div>
      <div class="a4-hdr-center">
        <div class="store-title">{{ storeName }}</div>
        {% if address %}
          <p>{{ address | replace('\\n', ', ') }}</p>
        {% endif %}
        {% if phone %}
          <p>Tel: {{ phone }}
            {% if whatsapp %}
              / {{ whatsapp }}
            {% endif %}
          </p>
        {% endif %}
        {% if email %}
          <p>{{ email }}</p>
        {% endif %}
        {% if website %}
          <p>{{ website }}</p>
        {% endif %}
      </div>
      <div class="a4-hdr-right">
        <div class="invoice-status">COURIER PARCEL</div>
        <div class="a4-meta-grid">
          <span class="a4-meta-lbl">Order:</span>
          <span class="a4-meta-val">{{ orderNo }}</span>
          <span class="a4-meta-lbl">Date:</span>
          <span class="a4-meta-val">{{ dateStr }}</span>
          {% if serviceType %}
            <span class="a4-meta-lbl">Service:</span>
            <span class="a4-meta-val">{{ serviceType }}</span>
          {% endif %}
          {% if trackingCode %}
            <span class="a4-meta-lbl">Tracking:</span>
            <span class="a4-meta-val" style="text-transform:none;">{{ trackingCode }}</span>
          {% endif %}
          {% if courierName %}
            <span class="a4-meta-lbl">Courier:</span>
            <span class="a4-meta-val">{{ courierName }}
              {% if courierPhone %}
                | {{ courierPhone }}
              {% endif %}
            </span>
          {% endif %}
        </div>
      </div>
    </div>
    <hr style="border:0;border-top:1px solid #333;margin:10px 0 15px 0;"/>
    {% if returnAddress %}
      <div class="return-box">
        <div class="return-label">If undelivered, return to:</div>
        <div style="font-size:0.9em;color:#333;line-height:1.5;">{{ returnAddress | replace('\\n', '<br/>') | safe }}</div>
      </div>
    {% endif %}
    <div class="a4-cust-card" style="margin-top:0;">
      <div class="deliver-to">DELIVER TO</div>
      <div class="a4-cust-grid">
        {% if showCustomer and customerName %}
          <span class="a4-cust-lbl">Name:</span>
          <span class="a4-cust-val">{{ customerName }}</span>
          {% if customerPhone %}
            <span class="a4-cust-lbl">Contact:</span>
            <span class="a4-cust-val">{{ customerPhone }}</span>
          {% endif %}
          {% if customerAddress %}
            <span class="a4-cust-lbl">Address:</span>
            <span class="a4-cust-val">{{ customerAddress }}</span>
          {% endif %}
          {% if customerEmail %}
            <span class="a4-cust-lbl">Email:</span>
            <span class="a4-cust-val" style="text-transform:none;">{{ customerEmail }}</span>
          {% endif %}
        {% else %}
          <span class="a4-cust-lbl">Name:</span>
          <span class="a4-cust-val" style="text-transform:none;">_________________________</span>
          <span class="a4-cust-lbl">Contact:</span>
          <span class="a4-cust-val" style="text-transform:none;">_________________________</span>
          <span class="a4-cust-lbl">Address:</span>
          <span class="a4-cust-val" style="text-transform:none;">_________________________</span>
        {% endif %}
      </div>
    </div>
    {% if altDeliveryAddress %}
      <div class="info-card">
        <div class="info-card-title">Alternative Delivery Address</div>
        <div style="font-size:0.9em;color:#2d3748;line-height:1.5;">{{ altDeliveryAddress | replace('\\n', '<br/>') | safe }}</div>
      </div>
    {% endif %}
    <div class="info-row-3">
      {% if deliveryInstructions %}
        <div class="info-card" style="flex:1;">
          <div class="info-card-title">Delivery Instructions</div>
          <div class="info-card-body">{{ deliveryInstructions }}</div>
        </div>
      {% endif %}
      {% if preferredDeliveryTime %}
        <div class="info-card" style="flex:1;">
          <div class="info-card-title">Preferred Time</div>
          <div class="info-card-body">{{ preferredDeliveryTime }}</div>
        </div>
      {% endif %}
      {% if deliveryZone %}
        <div class="info-card" style="flex:1;">
          <div class="info-card-title">Zone / Route</div>
          <div class="info-card-body">{{ deliveryZone }}</div>
        </div>
      {% endif %}
    </div>
    <hr style="border:0;border-top:1px solid #333;margin:10px 0 15px 0;"/>
    <div style="margin-bottom:16px;">
      <div class="section-title">Contents / Description</div>
      <div class="contents-text">{{ description }}</div>
    </div>
    {% if items.length > 0 %}
      <div style="margin-bottom:16px;">
        <table class="a4-items-table">
          <thead>
            <tr>
              <th class="a4-col-no" style="width:5%;">NO</th>
              <th class="a4-col-desc" style="width:50%;">ITEM</th>
              <th class="a4-col-qty" style="width:10%;">QTY</th>
              <th class="a4-col-price" style="width:18%;">SKU</th>
              <th class="a4-col-amount" style="width:12%;">CHK</th>
            </tr>
          </thead>
          <tbody>
            {% for item in items %}
              <tr class="a4-item-row">
                <td class="a4-col-no">{{ loop.index }}</td>
                <td class="a4-desc-cell">{{ item.product_name or item.item_name or item.name }}
                  {% if item.batch_no %}
                    <span style="color:#718096;font-size:0.85em;">({{ item.batch_no }})</span>
                  {% endif %}
                </td>
                <td class="a4-qty-cell">{{ item.quantity }}
                  {% if item.unit %}
                    {{ item.unit }}
                  {% endif %}
                </td>
                <td class="a4-price-cell" style="font-size:0.85em;color:#555;">{{ item.sku_code or "-" }}</td>
                <td class="a4-amount-cell" style="text-align:center;">[   ]</td>
              </tr>
            {% endfor %}
          </tbody>
        </table>
      </div>
    {% endif %}
    <div style="margin-bottom:16px;">
      <div class="section-title" style="font-size:0.9em;">Handling Instructions</div>
      <div class="h-grid">
        {% if isFragile %}
          <div class="h-label h-fragile">&#9888; FRAGILE</div>
        {% endif %}
        {% if thisSideUp %}
          <div class="h-label h-arrow">&#8593; THIS SIDE UP</div>
        {% endif %}
        {% if keepDry %}
          <div class="h-label h-dry">&#9730; KEEP DRY</div>
        {% endif %}
        {% if doNotStack %}
          <div class="h-label h-stack">&#10060; DO NOT STACK</div>
        {% endif %}
        {% if perishable %}
          <div class="h-label h-perish">&#127826; PERISHABLE</div>
        {% endif %}
        {% if hazardous %}
          <div class="h-label h-hazmat">&#9888; HAZARDOUS</div>
        {% endif %}
        {% if customHandling %}
          <div class="h-label" style="border:1px solid #a0aec0;color:#4a5568;background:#f7fafc;">{{ customHandling }}</div>
        {% endif %}
      </div>
    </div>
    <hr style="border:0;border-top:1px solid #333;margin:10px 0 15px 0;"/>
    <div class="a4-summary-container" style="margin-top:0;">
      <div class="a4-summary-left-card" style="width:48%;">
        <div class="a4-info-row">
          <span class="a4-info-label">Service</span>
          <span class="a4-info-value">{{ serviceType or "Standard" }}</span>
        </div>
        <div class="a4-info-row">
          <span class="a4-info-label">Total Items</span>
          <span class="a4-info-value">{{ totalItems }}</span>
        </div>
        {% if courierName %}
          <div class="a4-info-row">
            <span class="a4-info-label">Courier</span>
            <span class="a4-info-value">{{ courierName }}
              {% if courierPhone %}
                | {{ courierPhone }}
              {% endif %}
            </span>
          </div>
        {% endif %}
        {% if deliveryZone %}
          <div class="a4-info-row">
            <span class="a4-info-label">Zone</span>
            <span class="a4-info-value">{{ deliveryZone }}</span>
          </div>
        {% endif %}
        <div class="a4-info-row" style="border-bottom:none;margin-bottom:0;padding-bottom:0;">
          <span class="a4-info-label">Customer</span>
          <span class="a4-info-value">{{ "Included" if showCustomer else "Blank Space" }}</span>
        </div>
      </div>
      <div class="a4-summary-right-totals" style="width:48%;">
        <div class="a4-total-row">
          <span class="a4-total-lbl">Total</span>
          <span class="a4-total-val">{{ paidAmountFormatted }}</span>
        </div>
        {% if codAmount > 0 %}
          <div class="a4-total-row" style="font-weight:700;color:#b91c1c;">
            <span class="a4-total-lbl">COD</span>
            <span class="a4-total-val">{{ codAmountFormatted }}</span>
          </div>
        {% endif %}
        {% if deliveryFee > 0 or feePayer == "seller" %}
          {% if feePayer == "seller" %}
            <div class="a4-total-row">
              <span class="a4-total-lbl">Delivery Fee (Paid by Sender)</span>
              <span class="a4-total-val">{{ deliveryFeeFormatted }}</span>
            </div>
          {% else %}
            <div class="a4-total-row">
              <span class="a4-total-lbl">Delivery Fee (Paid by Recipient)</span>
              <span class="a4-total-val">{{ deliveryFeeFormatted }}</span>
            </div>
            <div class="a4-total-row" style="font-weight:700;color:#b91c1c;">
              <span class="a4-total-lbl">Total to Collect</span>
              <span class="a4-total-val">{{ collectTotalFormatted }}</span>
            </div>
          {% endif %}
        {% endif %}
      </div>
    </div>
    {% if feePayer == "seller" %}
      <div class="a4-info-row" style="border:1px solid #b91c1c;border-radius:6px;padding:8px 12px;margin-top:12px;">
        <span style="font-size:0.95em;color:#b91c1c;font-weight:700;">NOTE: Delivery fee of
          {{ deliveryFeeFormatted }} is paid by the sender.</span>
      </div>
    {% endif %}
    <div class="a4-signature-section">
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Sender</div>
      </div>
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Receiver</div>
      </div>
      <div class="a4-sig-block">
        <div class="a4-sig-line"></div>
        <div class="a4-sig-label">Delivery Time</div>
      </div>
    </div>
    <div class="a4-ftr">
      {% if returnAddressNote %}
        <div class="a4-ftr-note">{{ returnAddressNote }}</div>
      {% endif %}
      <div class="a4-ftr-note">{{ footer }}</div>
      <div class="a4-ftr-thank">Thank you!</div>
      {% if trackingCode %}
        <div style="margin-top:6px;">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=80x80&data={{ trackingCode }}"
            alt="QR"
            style="width:80px;height:80px;"/>
          <div style="font-size:0.75em;color:#777;margin-top:2px;letter-spacing:1px;">{{ trackingCode }}</div>
        </div>
      {% endif %}
      <div class="a4-ftr-powered">Powered by {{ webName }}</div>
    </div>
  </div>
{% else %}
  <div class="slim-container">
    <div class="slim-hdr">
      {% if logoUrl %}<img class="slim-logo" src="{{ logoUrl }}" alt="{{ storeName }}"/>{% endif %}
      <div class="slim-store">{{ storeName }}</div>
      {% if address %}
        <div class="slim-info">{{ address | replace('\\n', ', ') }}</div>
      {% endif %}
      {% if phone %}
        <div class="slim-info">Tel: {{ phone }}</div>
      {% endif %}
    </div>
    <div class="slim-divider"></div>
    {% if courierName %}
      <div style="margin-bottom:6px;">
        <div style="font-weight:700;font-size:0.7em;text-transform:uppercase;color:#4a5568;">Courier</div>
        <div class="slim-info" style="font-weight:700;">{{ courierName }}
          {% if courierPhone %}
            | {{ courierPhone }}
          {% endif %}
        </div>
      </div>
      <div class="slim-divider"></div>
    {% endif %}
    {% if returnAddress %}
      <div class="slim-return">
        <div style="font-weight:700;color:#b91c1c;font-size:0.7em;text-transform:uppercase;">RETURN TO:</div>
        <div class="slim-info">{{ returnAddress | replace('\\n', ', ') }}</div>
      </div>
      <div class="slim-divider"></div>
    {% endif %}
    <div style="margin-bottom:6px;">
      <div style="font-weight:700;font-size:0.85em;margin-bottom:4px;">DELIVER TO</div>
      {% if showCustomer and customerName %}
        <div class="slim-info" style="font-weight:700;">{{ customerName }}</div>
        {% if customerPhone %}
          <div class="slim-info">{{ customerPhone }}</div>
        {% endif %}
        {% if customerAddress %}
          <div class="slim-info">{{ customerAddress }}</div>
        {% endif %}
      {% else %}
        <div class="slim-info" style="border-bottom:1px solid #888;margin-bottom:4px;">&nbsp;</div>
        <div class="slim-info" style="border-bottom:1px solid #888;margin-bottom:4px;">&nbsp;</div>
        <div class="slim-info" style="border-bottom:1px solid #888;">&nbsp;</div>
      {% endif %}
    </div>
    {% if altDeliveryAddress %}
      <div class="slim-divider"></div>
      <div style="margin-bottom:6px;">
        <div style="font-weight:700;font-size:0.7em;text-transform:uppercase;color:#4a5568;">Alt Address</div>
        <div class="slim-info">{{ altDeliveryAddress | replace('\\n', ', ') }}</div>
      </div>
    {% endif %}
    {% if deliveryInstructions or preferredDeliveryTime or deliveryZone %}
      <div class="slim-divider"></div>
      <div style="margin-bottom:6px;">
        {% if deliveryInstructions %}
          <div class="slim-info">
            <strong>Instr:</strong>
            {{ deliveryInstructions }}</div>
        {% endif %}
        {% if preferredDeliveryTime %}
          <div class="slim-info">
            <strong>Time:</strong>
            {{ preferredDeliveryTime }}</div>
        {% endif %}
        {% if deliveryZone %}
          <div class="slim-info">
            <strong>Zone:</strong>
            {{ deliveryZone }}</div>
        {% endif %}
      </div>
    {% endif %}
    <div class="slim-divider"></div>
    <div style="margin-bottom:6px;">
      <div style="font-weight:700;font-size:0.8em;">Contents</div>
      <div class="slim-info">{{ description }}</div>
    </div>
    {% if items.length > 0 %}
      <table class="slim-table">
        <thead>
          <tr>
            <th align="left" style="width:55%;">Item</th>
            <th align="center" style="width:18%;">Qty</th>
            <th align="center" style="width:12%;">CHK</th>
          </tr>
        </thead>
        <tbody>
          {% for item in items %}
            <tr>
              <td>{{ item.product_name or item.item_name or item.name }}
                {% if item.batch_no %}
                  ({{ item.batch_no }}){% endif %}
              </td>
              <td align="center">{{ item.quantity }}
                {% if item.unit %}
                  {{ item.unit }}
                {% endif %}
              </td>
              <td align="center">[   ]</td>
            </tr>
          {% endfor %}
        </tbody>
      </table>
    {% endif %}
    <div class="slim-divider"></div>
    <div class="slim-h-grid">
      {% if isFragile %}
        <span class="slim-h-tag h-fragile">FRAGILE</span>
      {% endif %}
      {% if thisSideUp %}
        <span class="slim-h-tag h-arrow">UP</span>
      {% endif %}
      {% if keepDry %}
        <span class="slim-h-tag h-dry">DRY</span>
      {% endif %}
      {% if doNotStack %}
        <span class="slim-h-tag h-stack">NO STACK</span>
      {% endif %}
      {% if perishable %}
        <span class="slim-h-tag h-perish">PERISH</span>
      {% endif %}
      {% if hazardous %}
        <span class="slim-h-tag h-hazmat">HAZMAT</span>
      {% endif %}
      {% if customHandling %}
        <span class="slim-h-tag" style="border:1px solid #a0aec0;color:#4a5568;background:#f7fafc;">{{ customHandling }}</span>
      {% endif %}
    </div>
    <div class="slim-divider"></div>
    <div style="margin-bottom:4px;">
      <div style="display:flex;justify-content:space-between;font-size:0.82em;">
        <span>Total Items: {{ totalItems }}</span>
        <span>{{ serviceType or "Standard" }}</span>
      </div>
      <div style="display:flex;justify-content:space-between;font-size:0.82em;">
        <span>Total: {{ paidAmountFormatted }}</span>
        {% if codAmount > 0 %}
          <span style="color:#b91c1c;font-weight:700;">COD: {{ codAmountFormatted }}</span>
        {% endif %}
      </div>
      {% if deliveryFee > 0 or feePayer == "seller" %}
        {% if feePayer == "seller" %}
          <div style="display:flex;justify-content:space-between;font-size:0.82em;">
            <span>Delivery Fee (Paid by Sender)</span>
            <span>{{ deliveryFeeFormatted }}</span>
          </div>
          <div style="margin-top:3px;font-size:0.72em;color:#b91c1c;font-weight:700;">NOTE: Delivery fee of
            {{ deliveryFeeFormatted }} is paid by the sender.</div>
        {% else %}
          <div style="display:flex;justify-content:space-between;font-size:0.82em;">
            <span>Delivery Fee (Paid by Recipient)</span>
            <span>{{ deliveryFeeFormatted }}</span>
          </div>
          <div style="display:flex;justify-content:space-between;font-size:0.82em;color:#b91c1c;font-weight:700;">
            <span>Total to Collect</span>
            <span>{{ collectTotalFormatted }}</span>
          </div>
        {% endif %}
      {% endif %}
    </div>
    <div class="slim-divider"></div>
    <div>
      <div class="slim-info" style="text-align:center;font-size:0.7em;">
        Order: {{ orderNo }} | {{ dateStr }}
      </div>
      {% if trackingCode %}
        <div style="text-align:center;margin-top:4px;">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=60x60&data={{ trackingCode }}"
            alt="QR"
            style="width:60px;height:60px;"/>
          <div style="font-size:0.65em;color:#777;">{{ trackingCode }}</div>
        </div>
      {% endif %}
    </div>
    <div class="slim-divider"></div>
    <div style="display:flex;justify-content:space-between;font-size:0.75em;margin-bottom:6px;">
      <div style="text-align:center;">
        <div style="border-top:1px solid #333;width:80px;margin-bottom:2px;"></div>Sender</div>
      <div style="text-align:center;">
        <div style="border-top:1px solid #333;width:80px;margin-bottom:2px;"></div>Receiver</div>
    </div>
    <div class="slim-ftr">
      {% if returnAddressNote %}
        <div>{{ returnAddressNote }}</div>
      {% endif %}
      <div>{{ footer }}</div>
      <div style="font-weight:700;">Thank you!</div>
      <div style="font-size:0.7em;color:#999;">Powered by {{ webName }}</div>
    </div>
  </div>
{% endif %}`;

export const COURIER_PARCEL_CSS = `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: var(--cp-font, 13px);
  color: #000;
  background: #fff;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* ── A4 Layout ── */
.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  background: #fff;
  width: 100%;
  max-width: var(--cp-width, 210mm);
  margin: 0 auto;
  padding: var(--cp-pad, 10mm 12mm);
}

.a4-hdr-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.a4-hdr-left { width: 20%; }
.a4-hdr-logo-img { max-height: 80px; max-width: 100%; object-fit: contain; }
.a4-hdr-center { width: 50%; text-align: center; }
.a4-hdr-center .store-title { font-size: var(--cp-hdr-size, 1.5em); font-weight: 700; text-transform: uppercase; margin-bottom: 4px; }
.a4-hdr-center p { font-size: var(--cp-hdr-sub, 0.9em); margin: 2px 0; }
.a4-hdr-right { width: 30%; text-align: right; }
.a4-hdr-right .invoice-status { font-size: 1.1em; font-weight: 700; text-transform: uppercase; margin-bottom: 6px; }
.a4-meta-grid { display: grid; grid-template-columns: 80px 1fr; gap: 3px 8px; text-align: left; font-size: 0.9em; }
.a4-meta-lbl { font-weight: 500; color: #333; }
.a4-meta-val { font-weight: 700; }

.return-box { margin-bottom: 12px; border: 1px dashed #cbd5e0; border-radius: 6px; padding: 8px 12px; background: #fff9f0; }
.return-label { font-size: 0.75em; font-weight: 700; color: #b91c1c; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 2px; }

.deliver-to { font-weight: 700; font-size: 1.1em; margin-bottom: 6px; color: #1a202c; }
.a4-cust-card { margin: 10px 0 20px 0; font-size: 0.95em; }
.a4-cust-grid { display: grid; grid-template-columns: 140px 1fr; gap: 4px 10px; }
.a4-cust-lbl { font-weight: 500; color: #333; }
.a4-cust-val { font-weight: 700; text-transform: uppercase; }

.info-card { margin-bottom: 10px; padding: 8px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #f7fafc; }
.info-card-title { font-size: 0.7em; font-weight: 700; color: #4a5568; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 3px; }
.info-card-body { font-size: 0.85em; color: #2d3748; }
.info-row-3 { display: flex; gap: 12px; margin-bottom: 16px; }

.section-title { font-weight: 700; font-size: 1.05em; margin-bottom: 10px; text-transform: uppercase; border-bottom: 2px solid #dee2e6; padding-bottom: 6px; }
.contents-text { font-size: 1.1em; font-weight: 600; padding: 8px 0; min-height: 36px; border-bottom: 1px solid #dee2e6; }

.a4-items-table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 0.95em; }
.a4-items-table th, .a4-items-table td { border: 1px solid #888; padding: 8px 10px; }
.a4-items-table th { background-color: #f2f2f2; font-weight: 700; text-transform: uppercase; }
.a4-col-no { width: 5%; text-align: center; }
.a4-col-desc { width: 50%; text-align: left; }
.a4-col-qty { width: 10%; text-align: center; }
.a4-col-price { width: 18%; text-align: right; }
.a4-col-amount { width: 12%; text-align: right; }
.a4-item-row td { vertical-align: middle; }
.a4-item-row .a4-desc-cell { text-align: left; }
.a4-item-row .a4-qty-cell { text-align: center; }
.a4-item-row .a4-price-cell { text-align: right; }
.a4-item-row .a4-amount-cell { text-align: right; font-weight: 500; }

.h-grid { display: flex; flex-wrap: wrap; gap: 6px; }
.h-label { border-radius: 4px; padding: 4px 12px; font-size: 0.78em; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; border: 1px solid; }
.h-fragile { border-color: #fc8181; color: #c53030; background: #fff5f5; }
.h-arrow   { border-color: #63b3ed; color: #2b6cb0; background: #ebf8ff; }
.h-dry     { border-color: #9ae6b4; color: #276749; background: #f0fff4; }
.h-stack   { border-color: #f6ad55; color: #c05621; background: #fffaf0; }
.h-perish  { border-color: #f687b3; color: #b83280; background: #fff5f7; }
.h-hazmat  { border-color: #fc8181; color: #9b2c2c; background: #fff5f5; }

.a4-summary-container { display: flex; justify-content: space-between; align-items: flex-start; margin-top: 20px; gap: 30px; }
.a4-summary-left-card { width: 45%; background: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6; padding: 15px; }
.a4-info-row { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e9ecef; padding-bottom: 8px; margin-bottom: 8px; }
.a4-info-row:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
.a4-info-label { color: #495057; font-weight: 500; font-size: 0.9em; }
.a4-info-value { font-weight: 700; color: #212529; font-size: 0.9em; }
.a4-summary-right-totals { width: 45%; display: flex; flex-direction: column; gap: 8px; text-align: right; }
.a4-total-row { display: flex; justify-content: space-between; font-size: 0.95em; color: #495057; }

.a4-signature-section { display: flex; justify-content: space-between; margin-top: 50px; margin-bottom: 20px; padding: 0 10px; }
.a4-sig-block { width: 170px; text-align: center; }
.a4-sig-line { border-top: 1px solid #333; margin-bottom: 6px; }
.a4-sig-label { font-size: 0.85em; font-weight: 600; color: #495057; }

.a4-ftr { text-align: center; margin-top: 40px; font-size: var(--cp-ftr-size, 0.9em); line-height: 1.5; }
.a4-ftr-note { font-style: italic; margin-bottom: 6px; }
.a4-ftr-thank { font-weight: 700; font-size: 1.05em; }
.a4-ftr-powered { margin-top: 8px; font-size: 0.8em; color: #777; }

/* ── 80mm Slim Layout ── */
.slim-container {
  width: var(--cp-width, 72mm);
  margin: 0 auto;
  background: #fff;
  font-size: var(--cp-font, 11px);
  padding: var(--cp-pad, 4mm);
  line-height: 1.35;
}

.slim-hdr { text-align: center; margin-bottom: 6px; }
.slim-logo { max-height: 30px; max-width: 80%; object-fit: contain; margin-bottom: 4px; }
.slim-store { font-weight: 700; font-size: 1.05em; text-transform: uppercase; margin-bottom: 2px; }
.slim-info { font-size: 0.82em; color: #333; line-height: 1.4; }
.slim-divider { border-top: 1px dashed #888; margin: 6px 0; }
.slim-return { margin-bottom: 4px; }

.slim-table { width: 100%; border-collapse: collapse; margin: 6px 0; font-size: 0.78em; }
.slim-table th { background: #f2f2f2; border: 1px solid #888; padding: 4px 3px; font-size: 0.7em; text-transform: uppercase; }
.slim-table td { border: 1px solid #888; padding: 3px; font-size: 0.8em; }

.slim-h-grid { display: flex; flex-wrap: wrap; gap: 3px; margin: 4px 0; }
.slim-h-tag { border-radius: 3px; padding: 2px 6px; font-size: 0.65em; font-weight: 700; border: 1px solid; }

.slim-ftr { text-align: center; margin-top: 8px; font-size: 0.78em; color: #555; line-height: 1.4; }

@media print {
  body { background: #fff; padding: 0; }
  .a4-container { padding: 0; box-shadow: none; border-radius: 0; width: 100% !important; }
  .slim-container { padding: 2mm; }
  @page { size: var(--cp-page-size, A4) var(--cp-orientation, portrait); margin: 8mm; }
}`;
